import { Component, OnInit, inject } from '@angular/core';
import { PaymentsService } from '../../data-access/payments.service';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [
    PaymentsService
  ],
  selector: 'equine-ui-nx-testing',
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.scss']
})
export class TestingComponent implements OnInit {

  private paymentsService = inject(PaymentsService)
  private formBuilder = new FormBuilder();

  public productToOrderForm: FormGroup | undefined;
  public addToCartForm: FormGroup | undefined;
  public cartIdForm: FormGroup | undefined;
  private router = inject(Router);

  orderCreated: any;
  cartCreated: any;

  ngOnInit() {
    this.createproductToOrderForm();
    this.createCartForm();
    this.createCartIdForm();
  }

  createproductToOrderForm() {
    this.productToOrderForm = this.formBuilder.group({
      caseId: [''],
      product1: [''],
      qp1: [0],
      product2: [''],
      qp2: [0]
    }) as FormGroup;

    this.productToOrderForm.valueChanges.subscribe({
      next: (val) => {
        console.log('PROD_TO_ORDER', val)
      }
    })
  }

  createCartForm() {
    this.addToCartForm = this.formBuilder.group({
      reference: [''],
      order1: ['']
    }) as FormGroup;

    this.addToCartForm.valueChanges.subscribe({
      next: (val) => {
        console.log('CART', val)
      }
    })
  }

  createOrUpdateOrder() {

    const reference = this.productToOrderForm?.get('caseId')?.value;

    const prod1 = this.productToOrderForm?.get('product1')?.value;
    const q1 = this.productToOrderForm?.get('qp1')?.value;
    const prod2 = this.productToOrderForm?.get('product2')?.value;
    const q2 = this.productToOrderForm?.get('qp2')?.value;

    this.paymentsService.createOrderWithProducts(reference, [
      {
        productId: prod1,
        quantity: q1
      },{
        productId: prod2,
        quantity: q2
      }
    ], 'test').subscribe({
      next: (response) => {
        this.orderCreated = response;
      }
    });
  }


  createCartIdForm() {
    this.cartIdForm = this.formBuilder.group({
      cartId: ['']
    }) as FormGroup;

  }

  addToCart() {

    const reference = this.addToCartForm?.get('reference')?.value;
    const order1 = this.addToCartForm?.get('order1')?.value;

    this.paymentsService.addToCart(reference, [order1], 'paul').subscribe({
      next: (response) => {
        this.cartCreated = response;
      }
    });
  }


  payCart() {

    const cartId = this.cartIdForm?.get('cartId')?.value;
    this.router.navigate(['payments', 'payment-summary']);

  }

}
